<template lang="pug">
  #signUpSuccess
    .container-width.p-3
      .icon
        .icon-area
          .icon-success.mx-auto.text-center
            .mb-5
              .action.d-flex.align-items-center
                .trophy.mx-auto
                  .circle.mb-5
                    img(
                      :src='okImg',
                      alt='success_ok_img'
                    )
                    .light
                    .light.two
                    .light.three
                    .light.four
                    .light2
                    .light2.two
                    .light2.three
                    .light2.four
            h4(
              v-if="singUpAndBindSa"
            ) 會員開通成功且已綁定顧問成功!
            h4(
              v-else
            ) 會員綁定成功!
      p 恭喜您成功完成會員綁定，我們將不定期提供給您最新活動訊息。
      .fakePadding_h-50
      .row.p-3.pt-5.mx-2
        .col-12
          button.button.btn-block.button_clickCustom.button_clickCustom-primary.button_fixedAtBottom(
            type="button",
            @click="backToLINEHandler()"
          ) 返回官方帳號
</template>

<script>
import okImgUrl from '@/assets/images/icon/icon_ok.png';

export default {
  name: 'memberSuccess',
   props: {
    // 是否綁定成功且順便綁定顧問了
    singUpAndBindSa: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      okImg: okImgUrl
    };
  },
  mounted() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
  },
  methods: {
    backToLINEHandler() {
      window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
    }
  }
};
</script>

<style lang="scss" scoped>
#signUpSuccess {
    // background: url('~@/assets/images/bg/bg_success.png')no-repeat center center;
    background-size: contain;
    background-position-y: 30%;
}

.action {
  height: 30vh;
}
</style>
